import React, { useState, useEffect } from "react"

const FlyButton = ({ dataEventState }) => {
  const [open, setOpen] = useState(true)

  const onRedirect = () => {
    window.open(dataEventState?.link, "_blank")
  }

  useEffect(() => {
    setOpen(dataEventState?.is_show)
  }, [dataEventState])

  return (
    <>
      {open && (
        <div className="fixed w-[120px] h-[120px] sm:w-[150px] sm:h-[150px] md:w-[170px] md:h-[170px] 2xl:w-[250px] 2xl:h-[250px] right-6 bottom-[80px] xl:bottom-[18px] z-50">
          <img
            onClick={onRedirect}
            className="w-full h-full object-fill cursor-pointer"
            src={dataEventState?.icon_img}
            alt=""
          />
          <img
            onClick={() => setOpen(false)}
            className="absolute -top-2 -right-2 cursor-pointer"
            src="/closeFlyButton.png"
            width={24}
            height={24}
            alt=""
          />
        </div>
      )}
    </>
  )
}

export default FlyButton
